import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const RatingAndReviewsWrapper = t0 => {
  const $ = _c(5);
  const {
    children,
    href,
    onClick
  } = t0;
  const hasClick = href || onClick;
  let t1;
  if ($[0] !== children || $[1] !== hasClick || $[2] !== href || $[3] !== onClick) {
    t1 = <div className="flex justify-start">{hasClick ? <a className="flex items-center min-h-[16px] text-gray-light1 pr-[3px] !no-underline" onClick={onClick} href={href}>{children}</a> : <div className="flex items-center min-h-[16px] text-gray-light1 pr-[3px] !no-underline">{children}</div>}</div>;
    $[0] = children;
    $[1] = hasClick;
    $[2] = href;
    $[3] = onClick;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
RatingAndReviewsWrapper.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  onClick: PropTypes.func
};
export default RatingAndReviewsWrapper;